import { render, staticRenderFns } from "./EventPersonalization.vue?vue&type=template&id=4bb9ce4c&scoped=true"
import script from "./EventPersonalization.vue?vue&type=script&lang=js"
export * from "./EventPersonalization.vue?vue&type=script&lang=js"
import style0 from "./EventPersonalization.vue?vue&type=style&index=0&id=4bb9ce4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb9ce4c",
  null
  
)

export default component.exports